import { Output, EventEmitter, Injectable, Injector } from '@angular/core';
import { OffCanvasChildComponent } from '../model/off-canvas-child-component';
import { ViewRefDirective } from '../directives/view-ref.directive/view-ref.directive';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class OffCanvasService
{

    private viewRef: ViewRefDirective;
    private router: Router;

    public constructor(router: Router)
    {
        this.router = router;
        this.detectBrowserReturn();
    }

    //@Output('show')
    public open = new EventEmitter<any>();

    //@Output('hide')
    public hide = new EventEmitter<boolean>();

    //@Output('loaded')
    public loaded = new EventEmitter<boolean>();

    //@Output('requestEnableClose')
    public requestEnableClose = new EventEmitter<boolean>();

    public show<T extends OffCanvasChildComponent>(componentType: new (
        offCanvasService: OffCanvasService,
        injector: Injector
    ) => T, data: any): void
    {
        this.open.emit({ componentType, data });
    }

    public detectBrowserReturn(): void
    {
        this.router.events.subscribe((evt) =>
        {
          if (evt instanceof NavigationEnd)
          {
              this.close();
          }
        });
    }

    public enableClose(): void
    {
        this.requestEnableClose.emit(true);
    }

    public disableClose(): void
    {
        this.requestEnableClose.emit(false);
    }

    public close(): void
    {
        this.hide.emit();
    }

    public notifyLoaded(component: OffCanvasChildComponent): void
    {
        this.loaded.emit();
    }

    public getOffCanvasViewContainerRef(): ViewRefDirective
    {
        return this.viewRef;
    }

    public setOffCanvasViewContainerRef(viewRefDirective: ViewRefDirective): void
    {
        this.viewRef = viewRefDirective;
    }
}
